import { trimmValue } from '../helpers';

export const maxLength = (message: string, length: number) => (value: any) => {
  const trimmedValue = trimmValue(value);
  return trimmedValue && trimmedValue.length > length ? message : undefined;
};
